export const pressedButtonsOptions = {
  minusBtnPressed: {
    pressedBtn: 'minus',
    isPressedBtn: true,
  },
  minusBtnReleased: {
    pressedBtn: 'minus',
    isPressedBtn: false,
  },
  plusBtnPressed: {
    pressedBtn: 'plus',
    isPressedBtn: true,
  },
  plusBtnReleased: {
    pressedBtn: 'plus',
    isPressedBtn: false,
  },
};
